/*******************************************************
 * EXPLOITATION SERVICE
 *******************************************************/

"use strict";


/**
 * Module SERVICES
 */
angular.module("services")


/**
 * Service for the comptage module
 */
	.factory("ExploitationService",
		["$http", "SharedProperties", "ENV", "Utils", "$q", "DexieDatabaseService",
			function ($http, SharedProperties, ENV, Utils, $q, DexieDatabaseService) {

				// API private memebers
				var currentNetwork, currentLine, currentRoute, currentStopPoint, doZoom, doClearMarkers;

				// PUBLIC API
				return {
					getCountergroupNotCompleted: getCountergroupNotCompleted,
					deleteACountergroupNotCompleted: deleteACountergroupNotCompleted,
					fixACountergroupNotCompleted: fixACountergroupNotCompleted,
					getVehicleJourneysForJourneyPattern: getVehicleJourneysForJourneyPattern,
					getVehicleJourneysCount: getVehicleJourneysCount,
					getNonScheduledJourneys:getNonScheduledJourneys,
					getNetworkDetails: getNetworkDetails,
					getRoutesByStopAreaBoarding: getRoutesByStopAreaBoarding,
					getCoursesByType: getCoursesByType,
					deleteStopPoint: deleteStopPoint,
					removeStopPoints: removeStopPoints,
					updateStopAreaBoarding: updateStopAreaBoarding,
					updateVJASBoardingAndAlighting: updateVJASBoardingAndAlighting,
					updateVJBoardingAndAlighting: updateVJBoardingAndAlighting,
					updateStopAreaBoardingAndAlighting: updateStopAreaBoardingAndAlighting,
					updateLineBoardingAndAlighting: updateLineBoardingAndAlighting,
					updateLineWheelchairAccess: updateLineWheelchairAccess,
					updateLineBikeAccess: updateLineBikeAccess,
					updateLineSchoolBus: updateLineSchoolBus,
					removeDuplicateStopPoint: removeDuplicateStopPoint,
					updateOsrmProfileJourneyPatterns: updateOsrmProfileJourneyPatterns,
					getAllStopPoints: getAllStopPoints,
					getAllStopPointsForMap: getAllStopPointsForMap,
					getAllOkinaStopPointsForMap: getAllOkinaStopPointsForMap,
					getStopAreasForMap: getStopAreasForMap,
					getStopAreasCluster: getStopAreasCluster,
					getBoardingStopAreasDetailedByCoordinates: getBoardingStopAreasDetailedByCoordinates,
					getStopAreasByNetwork: getStopAreasByNetwork,
					getStopAreasCount: getStopAreasCount,
					getCourse: getCourse,
					getDeletedCourse: getDeletedCourse,
					getNonMobiitiStopAreas: getNonMobiitiStopAreas,
					getStopAreasWithoutOriginalStopId: getStopAreasWithoutOriginalStopId,
					getDuplicateOriginalStopId: getDuplicateOriginalStopId,
					getInconsistentStopPoints: getInconsistentStopPoints,
					getDestinations: getDestinations,
					getStopAreasItl: getStopAreasItl,
					deleteCourse: deleteCourse,
					getRealStopPointsByCoordinates: getRealStopPointsByCoordinates,
					searchStopPointsByName: searchStopPointsByName,
					deleteCourses: deleteCourses,
					updateCourse: updateCourse,
					addCourses: addCourses,
					getNetworks: getNetworks,
					updateNetworkCache: updateNetworkCache,
					getScholarNetworks: getScholarNetworks,
					getNetworksArchiveMode: getNetworksArchiveMode,
					getExploitationAnalyzeDay: getExploitationAnalyzeDay,
					getNetworkLinesInfoForStopPoint: getNetworkLinesInfoForStopPoint,
					getStopAreaFromMobiitiCode: getStopAreaFromMobiitiCode,
					getStopAreaFromOriginalStopId: getStopAreaFromOriginalStopId,
					getStopAreaByParentId:getStopAreaByParentId,
					getListSubscriberOnCourseUsingStopArea: getListSubscriberOnCourseUsingStopArea,

					/**
					 * Fetch all lines relaed to a network.
					 * @param networkId
					 * @returns {HttpPromise}
					 */
					getAllLines: getAllLines,
					getAllLinesBySchema: getAllLinesBySchema,
					getLine: getLine,
					getLines: getLines,
					getLinesArchiveMode: getLinesArchiveMode,
					getCategoriesForLines: getCategoriesForLines,
					getLinesCount: getLinesCount,
					initCodiflignes : initCodiflignes,
					getNetworkWithLines : getNetworkWithLines,
					getLinesSummary : getLinesSummary,
					getAvailablePostProcesses:getAvailablePostProcesses,

					/**
					 * Fetch all routes related to a line.
					 *
					 * @param lineId
					 * @returns {HttpPromise}
					 */
					getRoutes: getRoutes,
					getDeletedRoutes: getDeletedRoutes,

					setMapMatchingRoute: setMapMatchingRoute,
					downloadMapMatching: downloadMapMatching,
					checkAndInitGeoJson: checkAndInitGeoJson,
					getGeoJsonTrace: getGeoJsonTrace,
					resetGeoJsonTrace: resetGeoJsonTrace,
					getMapMatching: getMapMatching,
					requestOSRM: requestOSRM,
					getProfilesOsrm: getProfilesOsrm,
					getLatLngPointsMapMatching: getLatLngPointsMapMatching,

					/**
					 * Fetch routes related to a route
					 */
					getAssociatedGoJourneysFromJourney: getAssociatedGoJourneysFromJourney,
					getAssociatedBackJourneysFromJourney: getAssociatedBackJourneysFromJourney,

					/**
					 * Edit a network.
					 *
					 */
					editNetwork: editNetwork,
					deleteNetwork: deleteNetwork,
					deleteLine: deleteLine,
					deleteRoute: deleteRoute,

					/**
					 * Edit a line.
					 * @param line
					 * @returns {HttpPromise}
					 */
					editLine: editLine,
					updateDexie: updateDexie,
					deleteDexieLine: deleteDexieLine,
					setCategoryGroupOfLines: setCategoryGroupOfLines,

					/**
					 * Adds a new route.
					 * @param route
					 * @returns {HttpPromise}
					 */
					addOrUpdateRoute: addOrUpdateRoute,
					analysePostRoute: analysePostRoute,
					analyseDeleteStopPointsRoute: analyseDeleteStopPointsRoute,
					getValidated : getValidated,

					/**
					 * Adds a new course to a route.
					 * A course is a list of stop points with departure times.
					 *
					 * @param routeId
					 * @param stopPoints
					 * @returns {HttpPromise}
					 */
					addNewCourse: addNewCourse,
					addBoardingStopArea: addBoardingStopArea,
					addCommercialStopArea: addCommercialStopArea,
					getLineStopPoints: getLineStopPoints,
					getRoute: getJourneyPattern,
					getRouteAndNbStopArea30m: getRouteAndNbStopArea30m,
					getRouteGeojson: getRouteGeojson,

					/**
					 * Fetch all commercial names available.
					 * @returns {HttpPromise}
					 */
					getCommercialNames: getAllCommercialStopAreas,


					/**
					 * Export the comptage cart containing some courses.
					 * @param courses
					 * @returns {HttpPromise}
					 */
					exportComptage: exportComptage,

					/**
					 * Fetch all stats for a network and line.
					 * @param networkId
					 * @param lineId
					 * @param date1
					 * @param date2
					 * @returns {HttpPromise}
					 */
					getLineStats: getLineStats,

					/**
					 * Fetch all stats for a network / line / route / course.
					 * @param networkId
					 * @param lineId
					 * @param routeId
					 * @param courseId
					 * @param date1
					 * @param date2
					 * @returns {HttpPromise}
					 */
					getCourseStats: getCourseStats,
					getNetworkTrace: getNetworkTrace,
					getStopPointsByCoordinates: getStopPointsByCoordinates,
					getCourseSpeciale: getCourseSpeciale,
					getLineTopology: getLineTopology,

					/**
					 * Update the establishment position
					 */
					updateEstablishmentPosition: updateEstablishmentPosition,

					/**
					 * Returns current network. Can be used as a communication service between components.
					 */
					getCurrentNetwork: function () {
						return currentNetwork;
					},

					/**
					 * Returns current network. Can be used as a communication service between components.
					 */
					getCurrentLine: function () {
						return currentLine;
					},

					/**
					 * Returns current Route. Can be used as a communication service between components.
					 */
					getCurrentRoute: function () {
						return currentRoute;
					},

					/**
					 * Returns current StopPoint. Can be used as a communication service between components.
					 */
					getCurrentStopPoint: function () {
						return currentStopPoint;
					},

					/**
					 * Sets current network. Can be used as a communication service between components.
					 */
					setCurrentNetwork: function (network) {
						currentNetwork = network;
					},

					/**
					 * Sets current network. Can be used as a communication service between components.
					 */
					setCurrentLine: function (line) {
						currentLine = line;
					},

					/**
					 * Sets current route. Can be used as a communication service between components.
					 */
					setCurrentRoute: function (route) {
						currentRoute = route;
					},

					/**
					 * Sets current stopPoint. Can be used as a communication service between components.
					 */
					setCurrentStopPoint: function (stopPoint) {
						currentStopPoint = stopPoint;
					},

					resetLocalDbNetwork: resetLocalDbNetwork,

					/***
					 * Manual imports
					 */

					postVehicleJourneysFile: postVehicleJourneysFile,
					postManualStopsFile: postManualStopsFile,
					postKMLFile: postKMLFile,

					/**
					 * Import stop points
					 */
					postStopPointsImport: postStopPointsImport,

					getAllClients: getAllClients,

					getVariationsLines: getVariationsLines,
					getNewLines: getNewLines,
					getDeleteLines: getDeleteLines,

					getVariationsVehicleJourneys: getVariationsVehicleJourneys,
					getNewVehicleJourneys: getNewVehicleJourneys,
					getDeleteVehicleJourneys: getDeleteVehicleJourneys,

					getVariationsStops: getVariationsStops,
					getNewStops: getNewStops,
					getDeleteStops: getDeleteStops,
					getCircularReferenceCount: getCircularReferenceCount,
					getCircularReference: getCircularReference,

					getOverviewPredefinedExportsBySchema: getOverviewPredefinedExportsBySchema,
					getOverviewPredefinedExportsAllSchema: getOverviewPredefinedExportsAllSchema,
					getSynthesisAllSchema : getSynthesisAllSchema
				};

				/**
				 * Deletes the networkId row and all its lines children from local db with id networkId
				 *
				 * @param networkId
				 * @returns {*}
				 */
				function resetLocalDbNetwork(networkId, referential) {
					return DexieDatabaseService.getDb(referential).line
						.where({networkId: networkId})
						.delete()
						.then(() => {
							DexieDatabaseService.getDb(referential).network.delete(networkId);
						});
				}


				function getAllClients() {
					return $http.get(ENV.API_URL + "/admin/clients");
				}

				function updateNetworkCache(networks) {
					getAllClients().then((response) => {
						const data = response.data;
						for(let cpt in data) {
							let ref = data[cpt];
							for (var i = 0; i < networks.length; i++) {
								var network = networks[i];
								if(network.name != ref.name) continue;
								DexieDatabaseService.getDb(ref.code).getNetwork(network).then((foundNetwork) => {
									if (foundNetwork !== undefined) {
										if (foundNetwork.lastModified !== network.lastModified) {
											DexieDatabaseService.getDb(ref.code).network.delete(foundNetwork.id);
											DexieDatabaseService.getDb(ref.code).getLines(foundNetwork).then((lines) => {
												lines.forEach((line) => {
													DexieDatabaseService.getDb(ref.code).line.delete(line.id);
												});
											});
										}
									}
								});
							}
						}
					});
				}


				function getCoursesByType(type, id, useCache, showDisabled) {
					var paramsObject = {};
					paramsObject["token"] = SharedProperties.getApiToken();
					paramsObject[type] = id;
					paramsObject['showDisabled'] = showDisabled;

					return $http.get(ENV.API_URL + "/exploitation/course",
						{
							params: paramsObject,
							cache: useCache
						}
					);
				}

				function getVehicleJourneysForJourneyPattern(params) {
					return $http.get(ENV.API_URL + "/exploitation/course", {
						params: params
					});
				}

				function getVehicleJourneysCount() {
					return $http.get(ENV.API_URL + "/exploitation/course/count");
				}

				function getNetworkDetails() {
					return $http.get(ENV.API_URL + "/exploitation/reseau/details");
				}

				function getCountergroupNotCompleted(applicationMode) {
					return $http.get(ENV.API_URL + "/comptage/groupe-compteur/interrupted-courses", {
						params: {
							typeAppli: applicationMode
						}
					});
				}

				function deleteACountergroupNotCompleted(idCountergroup) {
					return $http.delete(ENV.API_URL + "/comptage/groupe-compteur/interrupted-courses/" + idCountergroup);
				}

				function fixACountergroupNotCompleted(idCountergroup) {
					return $http.post(ENV.API_URL + "/comptage/groupe-compteur/interrupted-courses/" + idCountergroup);
				}

				function getRoutesByStopAreaBoarding(boardingId) {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/" + boardingId + "/route-structure");
				}

				/**
				 * Get all stop points by network.
				 * @returns {HttpPromise}
				 */
				function getAllStopPoints() {
					return $http.get(ENV.API_URL + "/stop-areas/boarding");
				}

				/**
				 * Get all stop points for map display by network.
				 * @returns {HttpPromise}
				 */
				function getAllStopPointsForMap() {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/map");
				}


				/**
				 * Get all stop points for map display
				 *
				 * @returns {HttpPromise}
				 */
				function getAllOkinaStopPointsForMap() {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/map-disruption",
						{
							params: {
								token: SharedProperties.getApiToken(),
							}
						});
				}

				/**
				 * Get all stop points for map display
				 *
				 * @returns {HttpPromise}
				 */
				function getStopAreasForMap() {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/all-display-map",
						{
							params: {
								token: SharedProperties.getApiToken(),
							}
						});
				}

				/**
				 * Get all stop areas infos for given marker cluster
				 *
				 * @returns {HttpPromise}
				 */
				function getStopAreasCluster(stopAreasCluster) {

					if(!Array.isArray(stopAreasCluster)) return;

					stopAreasCluster = stopAreasCluster.map(sa => {
						return sa.options.id.toString()
					});

					return $http.get(`${ENV.API_URL}/stop-areas/boarding/cluster?`+
						Utils.buildListQueryParam("idsClusterTarget", stopAreasCluster));
				}

				/**
				 * Retourne la liste des points d'arrêts Boarding dans la box fournis avec les informations de ligne
				 * @param lat1
				 * @param lat2
				 * @param long1
				 * @param long2
				 * @returns {HttpPromise}
				 */
				function getBoardingStopAreasDetailedByCoordinates(lat1, lat2, long1, long2) {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/search-by-coordinates-detailed",
						{
							params: {
								token: SharedProperties.getApiToken(),
								latitude1: lat1,
								longitude1: long1,
								latitude2: lat2,
								longitude2: long2
							}
						});
				}

				/**
				 * Get all stop points by network
				 *
				 * @returns {HttpPromise}
				 */
				function getStopAreasByNetwork(networkId) {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/network/" + networkId);
				}

				function getStopAreasCount() {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/count");
				}

				function getCircularReferenceCount() {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/circularReference/count");
				}

				function getCircularReference() {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/circularReference");
				}

				/**
				 * Get network and lines informations of stop point
				 * @param stopPointId
				 * @returns {HttpPromise}
				 */
				function getNetworkLinesInfoForStopPoint(stopAreaId) {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/networkLines",
						{
							params: {
								token: SharedProperties.getApiToken(),
								stopAreaId: stopAreaId
							}
						});
				}

				/**
				 * Get a stopArea from a mobiiti code
				 * @param mobiitiCode
				 * @returns {HttpPromise}
				 */
				function getStopAreaFromMobiitiCode(mobiitiCode) {
					return $http.get(ENV.API_URL + "/stop-areas/stopAreaFromMobiitiCode",
						{
							params: {
								token: SharedProperties.getApiToken(),
								mobiitiCode: mobiitiCode
							}
						});
				}


				/**
				 * Get stopAreas with object id different than MOBIITI:xxxxxx (that shows a problem in DB)
				 * @returns {HttpPromise}
				 */
				function getNonMobiitiStopAreas() {
					return $http.get(ENV.API_URL + "/stop-areas/nonMobiitiStopAreas",
						{
							params: {
								token: SharedProperties.getApiToken()
							}
						});
				}


				/**
				 * Get stopAreas without original_sstop_id (that shows a problem in DB)
				 * @returns {HttpPromise}
				 */
				function getStopAreasWithoutOriginalStopId() {
					return $http.get(ENV.API_URL + "/stop-areas/stopAreasWithoutOriginalStopId",
						{
							params: {
								token: SharedProperties.getApiToken()
							}
						});
				}

				/**
				 * Get stopAreas with duplicates on original_stop_id
				 * @returns {HttpPromise}
				 */
				function getDuplicateOriginalStopId() {
					return $http.get(ENV.API_URL + "/stop-areas/duplicateOriginalStopIds",
						{
							params: {
								token: SharedProperties.getApiToken()
							}
						});
				}

				/**
				 * Get stop points that have an issue
				 * @returns {HttpPromise}
				 */
				function getInconsistentStopPoints() {
					return $http.get(ENV.API_URL + "/stop-points/findInconsistentStopPoints",
						{
							params: {
								token: SharedProperties.getApiToken()
							}
						});
				}

				function getNonScheduledJourneys() {
					return $http.get(ENV.API_URL + "/exploitation/course/nonscheduled",
						{
							params: {
								token: SharedProperties.getApiToken()
							}
						});
				}


				/**
				 * Get a stopArea from a originalStopId
				 * @param originalStopId
				 * @returns {HttpPromise}
				 */
				function getStopAreaFromOriginalStopId(originalStopId) {
					return $http.get(ENV.API_URL + "/stop-areas/stopAreaFromOriginalStopId",
						{
							params: {
								token: SharedProperties.getApiToken(),
								originalStopId: originalStopId
							}
						});
				}


				/**
				 * Get a stopArea from a mobiiti code
				 * @param mobiitiCode
				 * @returns {HttpPromise}
				 */
				function getStopAreaByParentId(parentIdParam) {
					return $http.get(ENV.API_URL + "/stop-areas/stopAreaByParentId",
						{
							params: {
								token: SharedProperties.getApiToken(),
								parentId: parentIdParam
							}
						});
				}

				function getListSubscriberOnCourseUsingStopArea(courseId, stopAreaId) {
					return $http.get(`${ENV.API_URL}/subscribers/list-on-vehicle-journey-using-stop-area?courseId=${courseId}&stopAreaId=${stopAreaId}`);
				}


				/**
				 * Récupérer une course par son ID
				 * @param courseId
				 * @returns {HttpPromise}
				 */
				function getCourse(courseId, useCache) {
					return $http.get(ENV.API_URL + "/exploitation/course/" + courseId,
						{
							cache: useCache ? useCache : false
						});
				}

				/**
				 * Récupère les courses supprimés d'un itinéraire supprimé
				 */
				function getDeletedCourse (courseId){
					return $http.get(ENV.API_URL + "/exploitation/course/deleted/" + courseId);
				}

				function getDestinations (lineId){
					return $http.get(ENV.API_URL + "/lines/" + lineId + "/destinations");
				}

				function getStopAreasItl (lineId, journeyPatternId, way){
					return $http.get(ENV.API_URL + "/stop-areas/itl-list",
						{
							params: {
								lineId: lineId,
								journeyPatternId: journeyPatternId,
								way: way
							}
						});
				}


				/**
				 * Delete a course given its ID.
				 * @param courseId
				 * @returns {HttpPromise}
				 */
				function deleteCourse(courseId) {
					return $http.delete(ENV.API_URL + "/exploitation/course/" + courseId,
						{
							params: {
								token: SharedProperties.getApiToken()
							}
						});
				}

				/**
				 * Delete a set of courses given its ID.
				 * @param coursesId
				 * @returns {HttpPromise}
				 */
				function deleteCourses(coursesId) {
					return $http.post(ENV.API_URL + "/exploitation/course/suppression",
						{
							token: SharedProperties.getApiToken(),
							coursesToDelete: coursesId
						}
					);
				}

				/**
				 * Delete a boarding point given its ID.
				 * @param courseId
				 * @returns {HttpPromise}
				 */
				function deleteStopPoint(stopPointId) {
					return $http.delete(ENV.API_URL + "/stop-areas/boarding/" + stopPointId,
						{
							params: {
								token: SharedProperties.getApiToken()
							}
						});
				}

				/**
				 * Supprime des PA d'une séquence d'arrêt
				 * @param jpId
				 * @param spIds
				 * @returns {HttpPromise}
				 */
				function removeStopPoints(jpId, spIds) {
					return $http.post(ENV.API_URL + "/exploitation/parcours/" + jpId + "/remove-points", spIds);
				}


				function updateCourse(routeId, course) {
					var postObject = {};
					postObject.route = routeId;
					postObject.courses = [];
					var vehicle_journey = [];
					for (var i = 0; i < course.horaires.length; i++) {
						var time = course.horaires[i];
						vehicle_journey.push({
							stop_area: course.horaires[i].stopId,
							departure_time: Utils.Converter.TimeToMillis(time.heure_depart),
							arrival_time: Utils.Converter.TimeToMillis(time.heure_arrivee),
							boarding_possibility: course.horaires[i].boarding_possibility
						});
					}
					postObject.courses.push({
						id: course.id,
						public_name: course.public_name,
						public_id: course.public_id,
                        mobilityRestrictedSuitable: course.mobilityRestrictedSuitable,
                        bikesAllowed: course.bikesAllowed,
						vehicle_journey: vehicle_journey
					});
					return $http.put(ENV.API_URL + "/exploitation/course/" + course.id , postObject);
				}

				function addCourses(routeId, coursePublicId, coursePublicName, coursesTimes) {
					var postObject = {};
					postObject.route = routeId;
					postObject.courses = [];
					for (var i = 0; i < coursesTimes.length; i++) {
						var courseTime = coursesTimes[i];
						var vehicle_journey = [];
						for (var j = 0; j < courseTime.length; j++) {
							var time = courseTime[j];
							vehicle_journey.push({
								stop_area: time.stop_area,
								departure_time: Utils.Converter.HHmmToMillis(time.departure_time),
								arrival_time: Utils.Converter.HHmmToMillis(time.arrival_time),
							});
						}
						postObject.courses.push({
							public_name: coursePublicName,
							public_id: coursePublicId,
							vehicle_journey: vehicle_journey
						});

					}
					return $http.post(ENV.API_URL + "/exploitation/course", postObject);
				}

				function getStopPointsByCoordinates(lat1, lat2, long1, long2) {
					return $http.get(ENV.API_URL + "/stop-areas/searchByCoordinates",
						{
							params: {
								token: SharedProperties.getApiToken(),
								latitude1: lat1,
								longitude1: long1,
								latitude2: lat2,
								longitude2: long2
							}
						}
					);
				}

				function getRealStopPointsByCoordinates(lat1, lat2, long1, long2) {
					return $http.get(ENV.API_URL + "/stop-points/searchByCoordinates",
						{
							params: {
								token: SharedProperties.getApiToken(),
								latitude1: lat1,
								longitude1: long1,
								latitude2: lat2,
								longitude2: long2
							}
						}
					);
				}


				/*
		 * Retourne tout les points d'arrêts recherchés par nom (ou les premiers dans le cas d'une recherche vide).
		 * @param name
		 * @returns StopPoints
		 */

				function searchStopPointsByName(name) {
					return $http.get(ENV.API_URL + "/stop-areas/boarding/light",
						{
							params: {
								token: SharedProperties.getApiToken(),
								name: name
							}
						}
					);
				}

				function getNetworks(useCache, isMosaicNetwork) {
					return $http.get(ENV.API_URL + "/exploitation/reseau",
						{
							params: {
								isMosaicNetwork: isMosaicNetwork
							},
							cache: useCache
						}
					);
				}

				function getScholarNetworks() {
					return $http.get(ENV.API_URL + "/exploitation/reseau?type=SCHOLAR");
				}

				function getNetworksArchiveMode(schemaName) {
					return $http.get(ENV.API_URL + "/exploitation/reseau?schemaName=" + schemaName,
						{
							cache: false
						}
					);
				}

				function getAllLines(useCache, isMosaicLines) {
					return $http.get(ENV.API_URL + "/lines",
						{
							params: {
								isMosaicLines: isMosaicLines
							},
							cache: useCache
						}
					);
				}

				function getAllLinesBySchema(schema) {
					return $http.get(ENV.API_URL + "/lines/all-lines-by-schema",
						{
							params: {
								schema: schema
							}
						}
					);
				}

				function getLine(lineid){
					return $http.get(ENV.API_URL + "/lines/"+lineid+"/info");
				}

				function getLines(networkId, useCache, isMosaicLines) {
					return $http.get(ENV.API_URL + "/lines",
						{
							params: {
								network: networkId,
								isMosaicLines: isMosaicLines
							},
							cache: useCache
						}
					);
				}

				function getNetworkWithLines(isMobiitiLines) {
					return $http.get(ENV.API_URL + "/lines/network-lines",
						{
							params: {
								isMobiitiLines: isMobiitiLines
							}
						}
					);
				}

				function getLinesArchiveMode(networkId, schemaName) {
					return $http.get(ENV.API_URL + "/lines",
						{
							params: {
								network: networkId,
								schemaName: schemaName
							},
							cache: false
						}
					);
				}

				function getCategoriesForLines(schemaName) {
					return $http.get(ENV.API_URL + "/lines/categories",
						{
							params: {
								schemaName: schemaName
							},
							cache: false
						}
					);
				}

				function initCodiflignes() {
					return $http.get(ENV.API_URL + "/lines/" + window.sessionStorage.referential + "/codiflignes");
				}

				function getLinesCount() {
					return $http.get(ENV.API_URL + "/lines/count"
					);
				}

				function getLinesSummary() {
					return $http.get(ENV.API_URL + "/lines/summary");
				}

				function getAvailablePostProcesses() {
					return $http.get(ENV.API_URL + "/post-process");
				}

				function getRoutes(lineId, useCache) {
					return $http.get(ENV.API_URL + "/exploitation/parcours",
						{
							params: {
								token: SharedProperties.getApiToken(),
								line: lineId
							},
							cache: useCache
						}
					);
				}

				function getDeletedRoutes(lineId){
					return $http.get(ENV.API_URL + "/exploitation/parcours/deleted_route/" + lineId);
				}

				/**
				 * Récupère les itinéraires associés aller
				 * @param routeId
				 * @returns {HttpPromise}
				 */
				function getAssociatedGoJourneysFromJourney(routeId) {
					return $http.get(ENV.API_URL + "/exploitation/parcours/" + routeId + "/associatedgo");
				}

				/**
				 * Récupère les itinéraires associés retour
				 * @param routeId
				 * @returns {HttpPromise}
				 */
				function getAssociatedBackJourneysFromJourney(routeId) {
					return $http.get(ENV.API_URL + "/exploitation/parcours/" + routeId + "/associatedback");
				}

				/**
				 * Edit a network, or use addNetwork function if network is new
				 * @param network
				 * @param isNewNetwork
				 * @returns {*}
				 */
				function editNetwork(network, isNewNetwork) {
					if (isNewNetwork) {
						return addNetwork(network);
					} else {

						return $http.put(ENV.API_URL + "/exploitation/reseau/" + network.id, network);
					}
				}

				function addNetwork(newNetwork) {
					return $http.post(ENV.API_URL + "/exploitation/reseau", newNetwork);
				}

				/**
				 * Delete a network given its ID.
				 * @param networkId
				 * @returns {HttpPromise}
				 */
				function deleteNetwork(networkId) {
					return $http.delete(ENV.API_URL + "/exploitation/reseau/" + networkId);
				}

				/**
				 * Delete a line given its ID on:
				 * - persistent database
				 * - local indexeddb
				 *
				 * @param lineId
				 * @returns {HttpPromise}
				 */
				function deleteLine(lineId) {
					return new Promise(function (resolve, reject) {
						$http.delete(ENV.API_URL + "/lines/" + lineId).then(() => {
							DexieDatabaseService.getDb().line.delete(lineId).then(() => {
								resolve(lineId);
							}).catch((error)=> {
								reject(error);
							});
						}).catch((error) => {
							reject(error.data.message);
						});
					});
				}

				/**
				 * Delete a route given its ID.
				 * @param routeId
				 * @returns {HttpPromise}
				 */
				function deleteRoute(routeId) {
					return $http.delete(ENV.API_URL + "/exploitation/parcours/" + routeId);
				}

				/**
				 * Edit (only) category for group of lines (1 at least)
				 * @param lines
				 * @returns {*}
				 */
				function setCategoryGroupOfLines(lines) {

					let group = lines;
					//Check however...
					if (!Array.isArray(group)) {
						group = [lines];
					}

					group = group.map(line => {
						// FIXME : do better than that...
						if (line.selectedForDisplay) {
							delete line.selectedForDisplay;
						}

						if (line.couleur && line.couleur.startsWith("#")) {
							line.couleur = line.couleur.slice(1);
						}
						return line;
					});

					return new Promise((resolve, reject) => {
						// On lance l'appel pour réaliser l'update en base de la ligne modifiée
						$http.put(ENV.API_URL + "/lines/" + window.sessionStorage.referential + "/set-category-idfm-for-lines",  group).then(response => {
							resolve(response.data);
						}).error(error => reject(error));
					});
				}

				/**
				 * Edit a line, or create a new one if not exists on:
				 * - Persistent db
				 * - local IndexedDb
				 *
				 * @param line
				 * @param isNewLine
				 * @param isOrderValidation true si l'appel provient de la validation de l'ordre des lignes (saveLinesOrder), pour tracer l'action distinctement d'une édition classique
				 * @returns {*}
				 */
				function editLine(line, isNewLine, isOrderValidation) {

					// FIXME : do better than that...
					if (line.selectedForDisplay) {
						delete line.selectedForDisplay;
					}

					if (line.couleur && line.couleur.startsWith("#")) {
						line.couleur = line.couleur.slice(1);
					}

					if (line.transportSubModeName == undefined || line.transportSubModeName.length === 0){
						line.transportSubModeName = undefined;
					}

					if (isNewLine) {
						return new Promise(function (resolve, reject) {
							// On lance l'appel pour réaliser l'insert en base de la nouvelle ligne
							$http.post(ENV.API_URL + "/lines/" + window.sessionStorage.referential+ "/create",  line).then(response => {
								const data = response.data;
								// On enregistre la nouvelle ligne dans la base locale indexedDb
								DexieDatabaseService.getDb().line.put({
									id: data.id,
									networkId: data.network.id,
									object_id: data.object_id,
									name: line.name,
									public_name: line.public_name,
									number: line.number,
									companyId: line.companyId,
									couleur: line.couleur,
									couleurTexte: line.couleurTexte,
									disable: false,
									itineraires: null,
									category: line.category,
									codifligne: line.codifligne,
									codifligneCommercial: line.codifligneCommercial,
									commentaire: line.commentaire,
									externalRef: line.externalRef,
									url: line.url,
									wheelchairAccess: line.wheelchairAccess,
									bikeAccess: line.bikeAccess,
									tad: line.tad,
									transportModeName: line.transportModeName,
									transportSubModeName: line.transportSubModeName
								}).then((insertedLine) => {
									resolve(insertedLine);
								}).catch((error) => {
									reject(error);
								});

							}).catch((error) => {
								reject(error.message);
							});
						});

					} else {
						return new Promise(function (resolve, reject) {
							// On lance l'appel pour réaliser l'update en base de la ligne modifiée
							let url = ENV.API_URL + "/lines/" +  window.sessionStorage.referential + "/" + line.id + "/";
							if (isOrderValidation) {
								url += "?orderValidation=true";
							}
							$http.put(url, line).then(response => {
								const data = response.data;
								// On met à jour la line dans la base IndexedDeb
								DexieDatabaseService.getDb().line.update(line.id, {
									object_id: data.object_id,
									name: data.name,
									public_name: data.public_name,
									number: data.number,
									companyId: data.companyId,
									couleur: data.couleur,
									couleurTexte: data.couleurTexte,
									category: data.category,
									codifligne: data.codifligne,
									codifligneCommercial: data.codifligneCommercial,
									commentaire: data.commentaire,
									externalRef: data.externalRef,
									url: data.url,
									wheelchairAccess: line.wheelchairAccess,
									bikeAccess: line.bikeAccess,
									tad: line.tad,
									position: line.position,
									transportModeName: line.transportModeName,
									transportSubModeName: line.transportSubModeName
								}).then(() => {
									resolve(data);
								}).catch((error) => {
									reject(error);
								});

							}).catch((error) => {
								reject(error.message);
							});
						});
					}
				}

				/**
				 * Pour mettre à jour la BD Dexie (navigateur) pour une ligne
				 */
				function updateDexie(referential, data){
						DexieDatabaseService.getDb(referential).line.update(data.id, {
						object_id: data.object_id,
						name: data.name,
						public_name: data.public_name,
						number: data.number,
						companyId: data.companyId,
						couleur: data.couleur,
						couleurTexte: data.couleurTexte,
						category: data.category,
						codifligne: data.codifligne,
						codifligneCommercial: data.codifligneCommercial,
						commentaire: data.commentaire,
						externalRef: data.externalRef,
						url: data.url,
						wheelchairAccess: data.wheelchairAccess,
						bikeAccess: data.bikeAccess,
						tad: data.tad,
						position: data.position,
						transportModeName: data.transportModeName,
						transportSubModeName: data.transportSubModeName
					}).then(() => {
						// nothing
					}).catch((error) => {
						// swallow
					});
				}

				function deleteDexieLine(referential, line){
					DexieDatabaseService.getDb(referential).deleteLine(referential, line);
				}

				/**
				 * Création d'un formatage pour la route
				 * @param route
				 * @param networkId
				 * @param lineId
				 * @param routeId
				 * @returns {{newRoute: {}, url: string}}
				 */
				function createParamRoute(route, networkId, lineId, routeId) {
					var newRoute = {};
					newRoute.name = route.name;
					newRoute.public_name = route.public_name;
					newRoute.network = networkId;
					newRoute.line = lineId;
					newRoute.direction = route.direction;
					newRoute.stop_points = [];
					for (var i = 0; i < route.stop_points.length; i++) {
						newRoute.stop_points.push(route.stop_points[i].id);}

					newRoute.stop_areas = []
					for (var i = 0; i < route.stop_points.length; i++) {
						newRoute.stop_areas.push({
							stop_point_id: route.stop_points[i].stop_point_id,
							distanceBetweenPreviousStopReal: route.stop_points[i].distanceBetweenPreviousStopReal,
						})
					}
					return newRoute;
				}

				/**
				 * Ajouter ou modifier la route
				 * @param route
				 * @param networkId
				 * @param lineId
				 * @param routeId
				 * @returns {HttpPromise}
				 */
				function addOrUpdateRoute(route, networkId, lineId, routeId, changePublishedNameAllVJ) {
					const newRoute = createParamRoute(route, networkId, lineId, routeId);
					let url = ENV.API_URL + "/exploitation/parcours";
					if (routeId) {
						url += "/" + routeId + "?changePublishedNameAllVJ=" + changePublishedNameAllVJ;
					}
					return $http.post(url, newRoute);
				}

				/**
				 * Lancer une analyse d'impact sur la route
				 * @param route
				 * @param networkId
				 * @param lineId
				 * @param routeId
				 * @returns {HttpPromise}
				 */
				function analysePostRoute(route, networkId, lineId, routeId) {
					var newRoute = createParamRoute(route, networkId, lineId, routeId);
					return $http.post(ENV.API_URL + "/analyze-impact/exploitation/route/" + routeId + "/update", newRoute);
				}

				/**
				 * Lancer une analyse d'impact sur la route
				 * @param route
				 * @param networkId
				 * @param lineId
				 * @param routeId
				 * @returns {HttpPromise}
				 */
				function analyseDeleteStopPointsRoute(route, networkId, lineId, routeId) {
					var newRoute = createParamRoute(route, networkId, lineId, routeId);
					return $http.post(ENV.API_URL + "/analyze-impact/exploitation/route/" + routeId + "/deletepoints", newRoute);
				}


				/**
				 * Récupère les autres jp validés
				 */
				function getValidated(journeyPatternId)
				{
					return $http.post(ENV.API_URL + "/exploitation/parcours/" + journeyPatternId + "/get-validated");
				}

				function addNewCourse(routeId, stopPoints) {
					var postObject = {};
					postObject.vehicle_journey = [];
					for (var i = 0; i < stopPoints.length; i++) {
						var stopPoint = stopPoints[i];
						postObject.vehicle_journey.push({
							"stop_area": stopPoint.id,
							"departure_time": Utils.Converter.time24HFormatToMilli(stopPoint.time)
						});
					}
					return $http.post(ENV.API_URL + "/exploitation/parcours/" + routeId + "/horaires", postObject);
				}

				/**
				 * Ajouter un point d'arrêt boarding
				 *
				 * @param stopPoint
				 * @returns {HttpPromise|*}
				 */
				function addBoardingStopArea(stopPoint) {
					delete stopPoint["style"];
					return $http.post(ENV.API_URL + "/stop-areas/boarding", stopPoint);
				}

				/**
				 * Modifier un point d'arrêt de type Boarding.
				 * @param stopArea
				 * @returns {*|HttpPromise}
				 */
				function updateStopAreaBoarding(stopArea) {
					delete stopArea["style"];
					delete stopArea["geoPoint"];
					delete stopArea["center"];
					return $http.put(ENV.API_URL + "/stop-areas/boarding/" + stopArea.id, stopArea);
				}

				function updateVJASBoardingAndAlighting(vjas) {
					return $http.post(ENV.API_URL
						+ "/exploitation/course/"
						+ vjas.vehicleJourneyId
						+ "/vjas-boarding-alighting-edit/"
						+ vjas.id
						+ "?enum=" + vjas.boardingAlightingPossibility);
				}

				function updateVJBoardingAndAlighting(vjId, boardingAlightingPossibility) {
					return $http.post(ENV.API_URL
						+ "/exploitation/course/"
						+ vjId
						+ "/vjas-boarding-alighting-edit/"
						+ "?enum=" + boardingAlightingPossibility);
				}

				function updateStopAreaBoardingAndAlighting(stopArea, way) {
					return $http.post(ENV.API_URL
						+ "/stop-areas/"
						+ stopArea.id
						+ "/boarding-alighting-edit/"
						+ "?enum=" + stopArea.boardingAlightingPossibility
						+ "&way=" + way);
				}

				function updateLineBoardingAndAlighting(lineId, lineMode, contactName, phoneNumber, mail, url) {
					return $http.post(ENV.API_URL
						+ "/lines/"
						+ lineId
						+ "/boarding-alighting-edit/"
						+ "?lineMode=" + lineMode
						+ "&contactName=" + contactName
						+ "&phoneNumber=" + phoneNumber
						+ "&mail=" + mail
						+ "&url=" + url);
				}

				function updateLineWheelchairAccess(lineId, wheelchair) {
					return $http.post(ENV.API_URL
						+ "/lines/"
						+ lineId
						+ "/wheelchair-access-edit"
						+ "?wheelchairAccess=" + wheelchair);
				}

				function updateLineBikeAccess(lineId, bike) {
					return $http.post(ENV.API_URL
						+ "/lines/"
						+ lineId
						+ "/bike-access-edit"
						+ "?bikeAccess=" + bike);
				}

				function updateLineSchoolBus(lineId, isSchoolBus) {
					return $http.post(ENV.API_URL
						+ "/lines/"
						+ lineId
						+ "/school-bus"
						+ "?schoolBus=" + isSchoolBus);
				}

				/**
				 * Met a jour les profil osrm des journeypatterns du stopPoint (requête longue)
				 * @param stopPoint
				 * @returns {HttpPromise}
				 */
				function updateOsrmProfileJourneyPatterns(stopPoint) {
					return $http.post(ENV.API_URL + "/stop-areas/" + stopPoint.id + "/update-osrm-profile-journey-patterns");
				}

				/**
				 *  Nettoyer une séquence de PA
				 *  @param jpId
				 *  @returns {*|HttpPromise}
				 */
				function removeDuplicateStopPoint(jpId) {
					return $http.post(ENV.API_URL + "/exploitation/parcours/" + jpId + "/removeduplicatestoppoints");
				}

				function addCommercialStopArea(commercialName, long, lat) {
					return $http.post(ENV.API_URL + "/stop-areas/commercial",
						{
							"token": SharedProperties.getApiToken(),
							"name": commercialName,
							"longitude": long,
							"latitude": lat
						});
				}

				function getLineStopPoints() {
					return $http.get(ENV.API_URL + "/comptage-simple/stop_points",
						{
							params: {
								token: SharedProperties.getApiToken()
							}
						}
					);
				}

				function getJourneyPattern(routeId, detailed, useCache) {
					if (detailed === undefined) {
						detailed = true;
					}
					return $http.get(ENV.API_URL + "/exploitation/parcours/" + routeId + "?detailed=" + detailed,
						{
							cache: useCache
						}
					);
				}

				function getRouteAndNbStopArea30m(routeId, useCache) {
					return $http.get(ENV.API_URL + "/exploitation/parcours/" + routeId + "/nbstoparea30m",
						{
							cache: useCache
						}
					);
				}

				function getRouteGeojson(routeId, useCache) {
					return $http.get(ENV.API_URL + "/exploitation/parcours/" + routeId + "?geojson=true",
						{
							cache: useCache
						}
					);
				}

				function setMapMatchingRoute(journeyPatternId, listPoints) {
					return $http.post(ENV.API_URL + "/exploitation/parcours/map-matching/" + journeyPatternId, listPoints);
				}

				function downloadMapMatching(journeyPatternId, format) {
					return $http.get(ENV.API_URL + "/exploitation/parcours/map-matching/" + journeyPatternId + "/export/" + format);
				}

				function checkAndInitGeoJson(ids) {
					return $http.post(ENV.API_URL + "/exploitation/parcours/check-and-init-geojson/" + ids);
				}

				function getGeoJsonTrace(journeyPatternId) {
					return $http.get(ENV.API_URL + "/exploitation/parcours/map-matching/" + journeyPatternId + "/geojson");
				}

				function resetGeoJsonTrace(journeyPatternId) {
					return $http.get(ENV.API_URL + "/exploitation/parcours/" + journeyPatternId + "/reset-trace")
				}

				function getMapMatching(journeyPatternId) {
					return downloadMapMatching(journeyPatternId, "GEOJSON");
				}

				function getExploitationAnalyzeDay(date) {
					return $http.get(ENV.API_URL + "/exploitation/analyze/" + date);
				}

				function requestOSRM(url) {
					return $http.get(ENV.API_URL + "/osrm/" + url);
				}

				function getProfilesOsrm(routeId) {
					return $http.get(ENV.API_URL + "/exploitation/parcours/map-matching/" + routeId + "/profiles");
				}

				function getLatLngPointsMapMatching(routeId) {
					return $http.get(ENV.API_URL + "/exploitation/parcours/map-matching/" + routeId + "/points");
				}

				function getAllCommercialStopAreas() {
					return $http.get(ENV.API_URL + "/stop-areas/commercial",
						{
							params: {
								token: SharedProperties.getApiToken()
							}
						});
				}

				function getAllCommercialStopAreasByNetwork(networkId) {
					return $http.get(ENV.API_URL + "/stop-areas/commercial/network",
						{
							params: {
								token: SharedProperties.getApiToken(),
								networkId: networkId
							}
						});
				}


				function exportComptage(courses, typeAppli) {
					var postObject = {};
					postObject.courses = [];
					for (var i = 0; i < courses.length; i++) {
						postObject.courses.push(courses[i].id);
					}
					return $http.post(ENV.API_URL + "/comptage/export/" + typeAppli, postObject);
				}

				function getLineStats(networkId, lineId, date1, date2) {
					return $http.get(ENV.API_URL + "/comptage/" + networkId + "/" + lineId,
						{
							params: {
								token: SharedProperties.getApiToken(),
								date1: date1,
								date2: date2
							}
						}
					);
				}

				function getCourseStats(networkId, lineId, routeId, courseId, date1, date2, nameAppli) {
					return $http.get(ENV.API_URL + "/comptage/" + networkId + "/" + lineId + "/" + routeId + "/" + courseId,
						{
							params: {
								token: SharedProperties.getApiToken(),
								date1: date1,
								date2: date2,
								nameAppli: nameAppli
							}
						}
					);
				}


				var networkTraceRequestCanceller;

				/**
				 * Récupérer le tracé d'un réseau.
				 * Retourne dans une promise cet objet : { fromCache: true/false, httpPromise : Promise}
				 * La seconde Promise correspond à celle qui retourne le résultat final
				 * @param networkId
				 * @returns {Promise}
				 */
				function getNetworkTrace(networkId, referential) {
					// Permet d'annuler la requête précédente.
					if (networkTraceRequestCanceller) {
						networkTraceRequestCanceller.resolve();
					}

					networkTraceRequestCanceller = $q.defer();
					// On retourne directement cet objet puisqu'on va retourner un ensemble de promises
					return DexieDatabaseService.getDb(referential).getLines(currentNetwork).then((lines) => {
						// Création de la première Promise qui va indiquer le chargement va être fait via le cache ou via une requete HTTP
						return new Promise(function (resolve) {
							var resolvedObject = {};
							if (lines !== undefined && lines.length > 0) {
								resolvedObject.fromCache = true;
								// Déclaration d'une promise permettant simplement de garder la même structure que lors d'une requete HTTP
								resolvedObject.promise = new Promise(function (resolve) {
									resolve(lines);
								});
							} else {
								// Lancement de la requete HTTP
								$http.get(ENV.API_URL + "/exploitation/reseau/" + networkId + "/trace",
									{
										timeout: networkTraceRequestCanceller.promise
									})
									.then((response) => {
										const data = response.data;
										if (data) {
											DexieDatabaseService.getDb(referential).network.put({
												networkId: data.id,
												name: data.name,
												lastModified: data.lastModified
											});
											if(data.lignes !== undefined) {
												data.lignes.forEach(function (line) {
													DexieDatabaseService.getDb(referential).line.put({
														id: line.id,
														name: line.name,
														public_name: line.public_name,
														number: line.number,
														object_id: line.object_id,
														companyId: line.companyId,
														couleur: line.couleur,
														disable: line.disable,
														itineraires: line.itineraires,
														networkId: line.network,
														category: line.category,
														codifligne: line.codifligne,
														codifligneCommercial: line.codifligneCommercial,
														wheelchairAccess: line.wheelchairAccess,
														bikeAccess: line.bikeAccess,
														tad: line.tad
													}).catch((error) => {
														reject("Erreur insertion ligne base de donnée locale", error);
													});
												});
												// Appel de la promise HTTP récupérée via le $q.defer();
												networkTraceRequestCanceller.resolve(data.lignes);
											}
										} else {
											console.log("lignes : data.lignes undefined");
										}
									});

								resolvedObject.fromCache = false;
								resolvedObject.promise = networkTraceRequestCanceller.promise;
							}
							// On retourne l'objet créé contenant le fromCache et la promise du resultat
							resolve(resolvedObject);
						});
					});
				}

				/**
				 * Récupérer une course spéciale par son ID
				 * @param courseSpecialeId
				 * @returns {HttpPromise}
				 */
				function getCourseSpeciale(courseSpecialeId, useCache) {
					return $http.get(ENV.API_URL + "/special-course/" + courseSpecialeId,
						{
							cache: useCache ? useCache : false
						});
				}

				/**
				 * Update the position for the given establishment uai
				 * @param establishment_uai
				 * @param latitude
				 * @param longitude
				 * @return {HttpPromise}
				 */
				function updateEstablishmentPosition(establishment_uai, latitude, longitude) {
					return $http.put(ENV.API_URL + "/institution/" + establishment_uai + "/update-position",
						{y: latitude, x: longitude});
				}

				/**
				 * Récupérer les points d'arrêt d'une ligne
				 * @param lineId
				 * @returns {HttpPromise}
				 */
				function getLineTopology(lineId) {
					return $http.get(ENV.API_URL + "/lines/" + lineId + "/topology");
				}

				/**
				 * Import fichier de courses
				 * @param file
				 * @returns {HttpPromise}
				 */
				function postVehicleJourneysFile(file, lineId) {
					let fd = new FormData();
					fd.append("file", file);
					fd.append("lineId",lineId);

					return $http.post(ENV.API_URL + "/imports/vehicleJourneysFile", fd, {
						transformRequest: angular.identity,
						headers: {"Content-Type": undefined}
					});
				}

				/**
				 * Import fichier d'arrets
				 * @param file
				 * @returns {HttpPromise}
				 */
				function postManualStopsFile(file) {
					let fd = new FormData();
					fd.append("file", file);

					return $http.post(ENV.API_URL + "/imports/manualStopsFile", fd, {
						transformRequest: angular.identity,
						headers: {"Content-Type": undefined}
					});
				}

				/**
				 * Import fichier KML
				 * @param jpId
				 * @param file
				 * @returns {*}
				 */
				function postKMLFile(file, jpId) {
					let fd = new FormData();
					fd.append("file", file);

					return $http.post(ENV.API_URL + "/imports/" + jpId +"/kml", fd, {
						transformRequest: angular.identity,
						headers: {"Content-Type": undefined}
					});
				}


				/**
				 * Importe la table de correspondance arrêt physique/tarifaire
				 * @param file
				 * @returns {HttpPromise}
				 */
				function  postStopPointsImport(file) {
					let fd = new FormData();
					fd.append("file", file);
					return $http.post(ENV.API_URL + "/imports/stop-points", fd, {
						transformRequest: angular.identity,
						headers: {"Content-Type": undefined}
					});
				}

				/**
				 * Récupérer les lignes qui varient d'un espace au super espace.
				 * @returns {HttpPromise}
				 */
				function getVariationsLines() {
					return $http.get(ENV.API_URL + "/variations/lines");
				}

				/**
				 * Récupérer les lignes ajoutées dans la nouvelle offre.
				 * @returns {HttpPromise}
				 */
				function getNewLines() {
					return $http.get(ENV.API_URL + "/variations/new-lines")
				}

				/**
				 * Récupérer les lignes supprimées dans la nouvelle offre.
				 * @returns {HttpPromise}
				 */
				function getDeleteLines() {
					return $http.get(ENV.API_URL + "/variations/delete-lines")
				}

				/**
				 * Récupérer les courses qui varient d'un espace au super espace (Mosaic).
				 * @returns {HttpPromise}
				 */
				function getVariationsVehicleJourneys() {
					return $http.get(ENV.API_URL + "/variations/vehicle-journeys")
				}

				/**
				 * Récupérer les courses ajoutées dans la nouvelle offre.
				 * @returns {HttpPromise}
				 */
				function getNewVehicleJourneys() {
					return $http.get(ENV.API_URL + "/variations/new-vehicle-journeys")
				}

				/**
				 * Récupérer les courses supprimées dans la nouvelle offre.
				 * @returns {HttpPromise}
				 */
				function getDeleteVehicleJourneys() {
					return $http.get(ENV.API_URL + "/variations/delete-vehicle-journeys")
				}

				/**
				 * Récupérer les arrêts qui varient d'un espace au super espace (Mosaic).
				 * @returns {HttpPromise}
				 */
				function getVariationsStops() {
					return $http.get(ENV.API_URL + "/variations/stop-areas")
				}

				/**
				 * Récupérer les arrêts ajoutés dans la nouvelle offre.
				 * @returns {HttpPromise}
				 */
				function getNewStops() {
					return $http.get(ENV.API_URL + "/variations/new-stops")
				}

				/**
				 * Récupérer les arrêts supprimés dans la nouvelle offre.
				 * @returns {HttpPromise}
				 */
				function getDeleteStops() {
					return $http.get(ENV.API_URL + "/variations/delete-stops")
				}

				/**
				 * Récupérer les urls publiques des configurations d'exports par schéma
				 * @param referential
				 * @returns {*}
				 */
				function getOverviewPredefinedExportsBySchema(referential) {
					return $http.get(ENV.API_URL + "/admin/overview/" + referential);
				}

				/**
				 * Récupérer les urls publiques des configurations d'exports de tous les schémas
				 * @returns {*}
				 */
				function getOverviewPredefinedExportsAllSchema() {
					return $http.get(ENV.API_URL + "/admin/overview/all/");
				}

				/**
				 * Récupérer la synthese de tous les schémas
				 * @returns {*}
				 */
				function getSynthesisAllSchema() {
					return $http.get(ENV.API_URL + "/admin/overview/allSynthesis/" );
				}
			}

		])
;


